module.exports = __webpack_public_path__ + "static/media/ih_kl.d60fe8fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pictures/ih_kl.png
// module id = 174
// module chunks = 0